var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyRightBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 468,
    viewBox: "0 0 443 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.676 0.0744991C266.704 2.12517 297.694 54.0756 333.963 88.7961C366.567 120.008 401.223 148.474 418.986 191.833C438.301 238.979 450.648 292.11 437.614 341.799C424.37 392.286 392.357 439.389 348.562 460.294C307.65 479.823 262.119 457.386 218.676 446.308C185.297 437.795 157.494 418.982 126.213 403.59C83.9644 382.801 20.9092 387.659 3.52753 340.443C-13.5737 293.99 36.1793 250.815 52.7903 204.146C68.0177 161.365 68.8711 112.906 96.7041 78.6657C128.907 39.0493 170.422 -1.98588 218.676 0.0744991Z",
    fill: "#FFEEAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyRightBackground);
export default __webpack_public_path__ + "static/media/buy-right-background.a1e9b8586d7e6ae632859c000ed90e78.svg";
export { ForwardRef as ReactComponent };